export default {
  getDefaultState: () => {
    return {
      exportFields: [],
      fileFormat: {},
      fileFormats: [],
      fileFormatsFilters: {},
      fileFormatsCurrentPage: 1,
      fileFormatsLastPage: 1,
      fieldMapping: {
        name: null,
        vatTypeMapping: {},
        categoryMappings: []
      },
      fieldsMapping: [],
      fieldsMappingFilters: {},
      fieldsMappingCurrentPage: 1,
      fieldsMappingLastPage: 1,
      erps: [],
      erpsCurrentPage: 1,
      erpsLastPage: 1,
      isCallingExportSettings: false
    }
  }
}
